
import BillOfLading from "@/store/modules/shipment/declarecustoms/billoflading";
import { Component, ActionButtonConfig, FormModalMixins, menuRouteHelper, systemConst,Prop,appConst, Watch} from "@/lib";


@Component
export default class BillOfLadingUploadModal extends FormModalMixins  {
  model = new BillOfLading();

  get record() {
    return this.$store.state.shipment.declarecustoms.billOfLading
  }
  created() {
      Object.assign(this.config, {modelTitleL: "app.DeclareCustoms.BillOfLadingUpload", labelWidth:100, width:600, okAction: "shipment/declarecustoms/billOfLadingUpload" });
  }

  @Watch("config.isShow")
  async onShowChange(value: boolean) {
      if (value && this.model.id) {
          const fileList = await this.$store.dispatch({ type: "shipment/declarecustoms/getBillOfLading" });
          if (fileList && fileList.length > 0) {
              this.model.fileList = fileList;
          }
      }
  }

  close() {
      this.config.isShow = false;
      this.model = new BillOfLading();
  }
}
